var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512.001",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.855 178.625c7.047 0 12.754-5.71 12.754-12.754 0-7.043-5.707-12.754-12.754-12.754-56.347 0-102.027 45.68-102.027 102.031 0 56.348 45.68 102.028 102.027 102.028 56.352 0 102.032-45.68 102.032-102.028 0-7.046-5.711-12.753-12.754-12.753-7.043 0-12.754 5.707-12.754 12.753 0 42.262-34.258 76.524-76.524 76.524-42.261 0-76.523-34.262-76.523-76.524 0-42.265 34.262-76.523 76.523-76.523zm0 0",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.2 179.395c-2.216-6.692-9.434-10.32-16.13-8.106-6.539 2.164-10.18 9.125-8.23 15.73 38.14 121.458-29.399 250.836-150.856 288.977-121.453 38.14-250.832-29.398-288.972-150.855C-2.133 203.684 65.41 74.305 186.863 36.164a230.521 230.521 0 0 1 138.121 0c6.75 2.035 13.871-1.785 15.907-8.535 2.004-6.649-1.672-13.676-8.278-15.824C197.75-30.508 54.117 44.52 11.805 179.387-30.508 314.25 44.523 457.883 179.387 500.195c134.867 42.313 278.496-32.715 320.808-167.582a255.934 255.934 0 0 0 .004-153.218zm0 0",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.145 91.117c.066-7.262-5.512-13.332-12.754-13.875-3.809-.324-7.621-.648-11.532-.648-98.613 0-178.554 79.941-178.554 178.554 0 98.61 79.941 178.551 178.554 178.551 98.61 0 178.551-79.941 178.551-178.55 0-4.614-.281-9.223-.847-13.801-1.02-7-7.52-11.848-14.52-10.828-7 1.015-11.848 7.52-10.832 14.52.039.265.086.526.14.792.278 3.09.551 6.152.551 9.309.004 84.527-68.515 153.046-153.039 153.054-84.527.004-153.047-68.52-153.05-153.043-.004-84.523 68.511-153.047 153.039-153.05h.003c3.165 0 6.23.273 9.313.546l2.39.2c6.665.285 12.297-4.887 12.579-11.551.004-.063.004-.121.008-.18zm0 0",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.379 114.855v45.735l-85.54 85.539c-5.066 4.894-5.206 12.969-.312 18.035 4.895 5.066 12.97 5.207 18.035.313.106-.102.211-.207.313-.313l85.54-85.539h45.733c3.383 0 6.625-1.344 9.02-3.738l76.52-76.524c4.98-4.98 4.98-13.054 0-18.035a12.749 12.749 0 0 0-9.016-3.734H435.41V38.332c0-7.043-5.71-12.754-12.758-12.75a12.747 12.747 0 0 0-9.011 3.734l-76.524 76.524a12.736 12.736 0 0 0-3.738 9.015zm25.508 5.282 51.015-51.016v20.227c0 7.043 5.711 12.754 12.754 12.754h20.227l-51.016 51.015h-32.98zm0 0",
    fill: "#677a58",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.dee829e8dd1dceccc970ae2124336b8b.svg";
export { ForwardRef as ReactComponent };